import Keycloak from 'keycloak-js';

const CLIENT_ID = 'combyn';
const REALM_NAME = 'combyn-realm';

export const url =
  process.env['NX_PUBLIC_KEYCLOAK_URL'] ?? 'http://localhost:8080';

let realm = REALM_NAME;

if (process.env['NX_PUBLIC_KEYCLOAK_REALM_OVERRIDE']) {
  realm = process.env['NX_PUBLIC_KEYCLOAK_REALM_OVERRIDE'];
  console.warn(`Overwritten realm: ${realm}`);
}

const keycloakConfig = {
  url,
  realm: realm,
  clientId: CLIENT_ID,
};
console.log(`Keycloak Config: `, keycloakConfig);

export function newKeycloakInstance() {
  return new Keycloak(keycloakConfig);
}
